import { useTranslation } from 'react-i18next';
import useActiveSection from '../../../../hooks/useScroll';
import style from './style.module.scss';
import { useNavigate } from 'react-router-dom';

export function NavBar({ onLinkClick }) {
    const { t } = useTranslation();

    const navItems = [
        { label: t('navbar.product'),    id: "product" },
        { label: t('navbar.advantages'), id: "advantages" },
        { label: t('navbar.features'),   id: "features" },
        { label: t('navbar.whyNexora'), id: "why-nexora" },
        { label: t('navbar.useCases'),  id: "use-cases" },
    ]

    const active = useActiveSection(navItems.map(item => item.id))
     const navigate = useNavigate();


    const handleClick = (id) => {
        navigate(`/#${id}`)
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
        onLinkClick?.()
    }

    return (
        <nav className={style["navbar"]}>
            {navItems.map((item, index) => (
                <button
                    key={index}
                    className={`${style["navbar__item"]} ${active === item.id ? style["navbar__itemActive"] : ""}`}
                    onClick={() => handleClick(item.id)}
                >
                    {item.label}
                </button>
            ))}
        </nav>
    )
}